import { render } from "./InfoBox.vue?vue&type=template&id=801b4afa"
import script from "./InfoBox.vue?vue&type=script&lang=js"
export * from "./InfoBox.vue?vue&type=script&lang=js"
script.render = render

export default script